import { FILE_HEADERS, HEADERS, JSON_HEADERS } from '../../Constants';

export const updateTokenForHeaders = token => {
  const authorization = `Bearer ${token}`;
  FILE_HEADERS.Authorization = authorization;
  HEADERS.Authorization = authorization;
  JSON_HEADERS.Authorization = authorization;
  localStorage.setItem('token', token);
};
